const EVENTO = '.EquipmentRetentionChanged'

export default {
  data() {
    return {
      retentionEventsChannelName: null,
      retentionEventsListener: null,
    }
  },

  methods: {
    watchRetentionEvents() {
      if (typeof window.Echo === 'undefined') return
      if (this.retentionEventsListener) return

      const node = this.$store.state.selected_node
      if (!node || !node.id) return

      this.retentionEventsChannelName = `node.${node.id}`
      this.retentionEventsListener = payload => {
        if (!payload || !payload.retention_id) return
        if (typeof this.onRetentionEvent === 'function') this.onRetentionEvent(payload)
      }

      window.Echo.private(this.retentionEventsChannelName).listen(EVENTO, this.retentionEventsListener)
    },

    unwatchRetentionEvents() {
      if (typeof window.Echo === 'undefined') return
      if (!this.retentionEventsChannelName || !this.retentionEventsListener) return

      // stopListening e nao leave(): o canal do no e compartilhado com despachos,
      // posicoes e o feed de ocorrencias.
      window.Echo.private(this.retentionEventsChannelName)
        .stopListening(EVENTO, this.retentionEventsListener)

      this.retentionEventsChannelName = null
      this.retentionEventsListener = null
    },
  },

  beforeDestroy() {
    this.unwatchRetentionEvents()
  },
}
